import { Component, OnInit, Input } from '@angular/core';
import { StorageManagerService} from '../../shared/services/index';
import { FormGroup, FormBuilder, FormArray } from '@angular/forms';
import { BaseAccordionComponent } from '../base-accordion/base-accordion.component';
import { FeatureService } from '../../shared/services/feature.service';

@Component({
  selector: 'app-model-identification-classification',
  templateUrl: './model-identification-classification.component.html',
  styleUrls: ['./model-identification-classification.component.scss']
})
export class ModelIdentificationClassificationComponent extends BaseAccordionComponent implements OnInit {
  @Input() showLegacy: boolean = false;

  constructor(public fb: FormBuilder, public storage: StorageManagerService) {
    super(fb, storage);
  }

  ngOnInit() {

    this.itemType = this.itemData.documentType;
    this.dataScope = this.storage.read('dataScope');
    this.itemDetails = location.pathname.includes('/itemdetails');

    this.initializeMainForm();

    this.patchForms();
  }

  initializeMainForm() {

    this.deviceForm = this.fb.group({
      budi: ['', { validators: [] }],
      bAgency: ['', { validators: [] }],
      applicableLegislation: ['', { validators: [] }],
      deviceRiskClass: ['', { validators: [] }],
      deviceModel: ['', { validators: [] }],
      deviceName: ['', { validators: [] }],
      manufacturerSRN: ['', { validators: [] }],
      multiComponentDeviceType: ['', { validators: [] }],
      specialDeviceType: ['', { validators: [] }],
      sppProducerSRN: ['', { validators: [] }],
      sppType: ['', { validators: [] }],
      authRepSRN: ['', { validators: [] }],
      eudamedDi: ['', { validators: [] }],
      eudamedDiIssuingAgency: ['', { validators: [] }],
      eudamedIdIssuingAgency: ['', { validators: [] }]
    });

    // Watch changes on the entire deviceForm
    this.deviceForm.valueChanges.subscribe(data => {
      this.logValidationErrors(this.deviceForm);
    });
  }


  patchForms() {
    this.deviceForm.patchValue({
      budi: this.displayItemData('BUDI-DI'),
      bAgency: this.displayItemData('BUDI-DI Issuing Agency'),
      applicableLegislation: this.displayItemData('Applicable Legislation'),
      deviceRiskClass: this.displayItemData('Device Risk Class'),
      deviceModel: this.displayItemData('Device Model'),
      deviceName: this.displayItemData('Device Name'),
      manufacturerSRN: this.displayItemData('Manufacturer SRN'),
      multiComponentDeviceType: this.displayItemData('Multi-Component Device Type'),
      specialDeviceType: this.displayItemData('Special Device Type'),
      sppProducerSRN: this.displayItemData('System or Procedure Pack Producer SRN'),
      sppType: this.displayItemData('SPPType'),
      authRepSRN: this.displayItemData('Authorized Representative SRN'),
      eudamedDi: this.displayItemData('Eudamed DI'),
      eudamedDiIssuingAgency: this.displayItemData('Eudamed DI Issuing Agency'),
      eudamedIdIssuingAgency: this.displayItemData('Eudamed ID Issuing Agency')
    });
  }
}




